import { mapState, mapActions } from 'vuex'

export default {
  name: 'Confirm',
  data () {
    return {
      defaultTitle: '',
      defaultBody: '',
      defaultAcceptLabel: '承認',
      defaultDenyLabel: 'キャンセル'
    }
  },
  computed: {
    ...mapState({
      active: state => state.confirm.active,
      title: state => state.confirm.title,
      body: state => state.confirm.body,
      acceptLabel: state => state.confirm.acceptLabel,
      denyLabel: state => state.confirm.denyLabel
    }),
    getTitle () {
      return this.title || this.defaultTitle
    },
    getBody () {
      return this.body || this.defaultBody
    },
    getAcceptLabel () {
      return this.acceptLabel || this.defaultAcceptLabel
    },
    getDenyLabel () {
      return this.denyLabel || this.defaultDenyLabel
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      hide: 'confirm/hide',
      accept: 'confirm/accept'
    }),
    /**
     * ダイアログを閉じる
     */
    closeDialog () {
      this.hide()
    },
    /**
     * メッセージを許諾する
     */
    acceptConfirm () {
      // this.$emit('childs-event', {
      //   accept: true
      // })

      this.accept()
      this.$nextTick(() => {
        this.hide()
      })
    }
  }
}